import axiosInstance from '../../axiosInstance';

const removeSharingToForUser = async ({ userId, sharingToUserId }) => {
  await axiosInstance.delete(
    `/api/admin/v2/users/${userId}/sharing-to-accounts/${sharingToUserId}`,
  );
};

export default removeSharingToForUser;
